import { INPUT_SUB_TYPE, INPUT_TYPE } from "./input-types";
import { department } from "../../../info-technology-process/data";

export const eContentFields = [
  {
    label: "Mã NV",
    field: "registerPersonel",
    type: INPUT_TYPE.TEXT,
    require: true,
    span: 12,
  },
  {
    label: "Họ và tên",
    field: "fullName",
    type: INPUT_TYPE.TEXT,
    require: true,
    span: 12,
  },
  {
    label: "Đơn vị",
    field: "unit",
    type: INPUT_TYPE.TEXT,
    require: true,
    span: 12,
  },
   {
    label: "Mã E-learning",
    field: "eLearningCode",
    type: INPUT_TYPE.TEXT,
    require: true,
    span: 12,
  },
  {
    label: "Password",
    field: "password",
    type: INPUT_TYPE.TEXT,
    require: true,
    span: 12,
  },
  {
    label: "Số tiết",
    field: "numLessons",
    type: INPUT_TYPE.TEXT,
    require: true,
    span: 12,
    rules: [
      {
        message: "Giá trị không hợp lệ",
        pattern: new RegExp(/^[0-9]+$/),
      },
    ],
  },
  {
    label: "Trạng thái",
    field: "status",
    type: INPUT_TYPE.SELECT,
    options: [
      {
        value: "Hủy",
        label: "Hủy",
      },
      {
        value: "Không hủy",
        label: "Không hủy",
      },
       {
        value: "Vắng",
        label: "Vắng",
      },
    ],
    require: true,
    span: 12,
  },
   {
    label: "Email",
    field: "email",
    type: INPUT_TYPE.TEXT,
    subType: INPUT_SUB_TYPE.EMAIL,
    require: true,
    span: 12,
  },
  {
    label: "Chức vụ",
    field: "position",
    type: INPUT_TYPE.TEXT,
    require: true,
    span: 12,
  },
  {
    label: "Điện thoại",
    field: "phoneNumber",
    type: INPUT_TYPE.TEXT,
    require: true,
    span: 12,
    rules: [
      {
        message: "Giá trị không hợp lệ",
        pattern: new RegExp(/^[0-9]{1,10}$/),
      },
    ],
  },
  {
    label: "Ghi chú",
    field: "note",
    type: INPUT_TYPE.TEXT,
    require: false,
    span: 24,
  },
];

export const formFields = [
  {
    type: INPUT_TYPE.SELECT,
    options: department,
    label: "Đơn vị",
    require: true,
    field: "eDepartment",
    span: 12,
    placeholder:"Chọn đơn vị"
  },
  {
    type: INPUT_TYPE.SELECT,
    options: [
      {
        value: "Đào tạo IOSA",
        label: "Đào tạo IOSA",
      },
    ],
    label: "Nghiệp vụ",
    require: true,
    field: "eMajor",
    span: 12,
    placeholder:"Chọn nghiệp vụ"
  },
  // {
  //   type: INPUT_TYPE.SELECT,
  //   options: [
  //     {
  //       value: "Đào tạo IOSA",
  //       label: "Đào tạo IOSA",
  //     },
  //   ],
  //   label: "Môn học",
  //   require: true,
  //   field: "eCourse",
  //   span: 12,
  // },
  {
    type: INPUT_TYPE.SELECT,
    options: [
      {
        value: "ĐỊNH KỲ",
        label: "ĐỊNH KỲ",
      },
      {
        value: "BAN ĐẦU",
        label: "BAN ĐẦU",
      },
      {
        value: "PHỤC HỒI",
        label: "PHỤC HỒI",
      },
      {
        value: "BỒI DƯỠNG KT",
        label: "BỒI DƯỠNG KT",
      }
    ],
    label: "Loại hình đào tạo",
    require: true,
    field: "eTrainingType",
    span: 12,
    placeholder:"Chọn loại hình đào tạo"
  },
];

export const additionalFormFields = [
  {
    label: "Mã số",
    field: "eIssueNumber",
    type: INPUT_TYPE.TEXT,
    defaultValue:"V.TMM-F23",
    require: true,
    span: 8,
  },
  {
    label: "Ban hành",
    field: "eIssueTimes",
    type: INPUT_TYPE.TEXT,
    defaultValue:"04",
    require: true,
    span: 8,
  },
  {
    label: "Hiệu lực",
    field: "eIssueEffectiveDate",
    type: INPUT_TYPE.DATE_TIME,
    defaultValue:"2022-12-01",
    require: true,
    span: 8,
  },
];
